import axios from 'axios'
import { getUserToken } from './utility/localStorageFunctions'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/platforms-api`

async function getPlatforms() {
  const token = await getUserToken('platforms')

  const response = await axios({
    method: 'get',
    url: BASE_URL.concat(`/platforms`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

async function getPlatform(clientId: number) {
  const token = await getUserToken('platforms')

  const response = await axios({
    method: 'get',
    url: BASE_URL.concat(`/platforms/${clientId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

async function createPlatform() {
  const token = await getUserToken('platforms')

  const response = await axios({
    method: 'POST',
    url: BASE_URL.concat(`/platforms`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {},
  })
  return response.data
}

export const platformAPI = {
  getPlatform,
  getPlatforms,
  createPlatform,
}
